import { Component, OnInit, inject } from '@angular/core';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { ProfileService } from './shared/services/profile.service';
import { Router } from '@angular/router';
import { NgIf } from '@angular/common';
import { AccountTypeChangeModalComponent } from './shared/components/account-type-change-modal/account-type-change-modal.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  imports: [IonApp, IonRouterOutlet, NgIf, AccountTypeChangeModalComponent, TranslatePipe],
})
export class AppComponent implements OnInit {
  private readonly profileService = inject(ProfileService);
  private readonly router = inject(Router);

  showBanner = false;

  ngOnInit() {
    this.profileService.myProfile$.subscribe(profile => {
      this.showBanner = !!profile
        && (profile.primaryRole === 2 || profile.primaryRole === 3)
        && !profile.isProfileApproved;
    });

    this.profileService.fetchMyProfile().catch(console.error);
  }

  goToOnboarding() {
    this.router.navigate(['/onboarding'], {
      queryParams: {
        source: 'profile_banner',
      },
    });
  }
}
